export const removeScroll = () => {
  document.body.style.overflow = 'hidden';
}

export const addScroll = () => {
  document.body.style.overflow = 'auto';
}